import { Grid, Tooltip } from "@material-ui/core";
import {
  InputCheckboxMaster,
  InputOptionMaster,
  InputTextMaster,
  MasterButton
} from "App/Component/ui";
import { TYPE_INSTANCE1 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { isNull } from "App/utils/helpers";
import { useSelector } from "react-redux";
import { LIST_URL_REGISTRASI } from "utils/registrations";
import {
  useLayananRuang,
  useScehuldeDokter,
  valueJenisAntrian,
} from "./helpers";
import { SelectIcon } from "App/Assets"

const FormAntrian = ({
  formData,
  handleChange,
  setFormData,
  dokterSelect,
  dokterList,
  poliklinik,
  registrasiId,
  handleShowCekResepIter
}) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <p className='fw-600 mt-2 fs-12'>ANTRIAN</p>
        </Grid>
        {!isNull(registrasiId) && (
          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.is_update_jadwal}
              name='is_update_jadwal'
              id='is_update_jadwal'
              label='Apakah ingin mengubah jadwal?'
              onChange={() =>
                setFormData({
                  ...formData,
                  is_update_jadwal: !formData.is_update_jadwal,
                })
              }
            />
          </Grid>
        )}
      </Grid>
      <div className='mt-05'>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputOptionMaster
              name='jenis_antrian'
              label='JENIS ANTRIAN'
              id='jenis_antrian'
              withSearch={false}
              data={valueJenisAntrian}
              value={formData.jenis_antrian}
              disabled={
                isNull(registrasiId)
                  ? false
                  : formData.is_update_jadwal
                  ? false
                  : true
              }
              readOnly={
                isNull(registrasiId)
                  ? false
                  : formData.is_update_jadwal
                  ? false
                  : true
              }
              onChange={handleChange("jenis_antrian")}
            />
          </Grid>

          <JenisAntrian
            handleChange={handleChange}
            formData={formData}
            setFormData={setFormData}
            dokterSelect={dokterSelect}
            dokterList={dokterList}
            poliklinik={poliklinik}
            registrasiId={registrasiId}
            handleShowCekResepIter={handleShowCekResepIter}
          />
        </Grid>
      </div>
    </>
  );
};

export default FormAntrian;

const JenisAntrian = ({
  formData,
  handleChange,
  setFormData,
  dokterSelect,
  dokterList,
  poliklinik,
  registrasiId,
  handleShowCekResepIter
}) => {
  const layanan = useSelectOption(
    false,
    LIST_URL_REGISTRASI.kunjungan_rawat_jalan.layanan,
    TYPE_INSTANCE1
  );

  const scheduleDokter = useScehuldeDokter(formData.doctor_id);
  const layananRuang = useLayananRuang(formData.layanan_id);

  if (formData.jenis_antrian === "1") {
    return (
      <>
        <FormDokter
          setFormData={setFormData}
          formData={formData}
          dokterList={dokterList}
          dokterSelect={dokterSelect}
          registrasiId={registrasiId}
        />

        <Grid item xs={4}>
          <InputOptionMaster
            name='poliklinik_id'
            label='POLIKLINIK'
            id='poliklinik_id'
            withSearch={true}
            data={poliklinik}
            value={formData.poliklinik_id}
            labelValue={formData.poli_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  poliklinik_id: null,
                  poli_name: "Pilih Poliklinik",
                });
              } else {
                setFormData({
                  ...formData,
                  poliklinik_id: e?.value,
                  poli_name: e?.label,
                });
              }
            }}
            disabled={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
            readOnly={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InputOptionMaster
            name='schedule_doctor_id'
            label='SCHEDULE DOKTER'
            id='schedule_doctor_id'
            withSearch={false}
            data={scheduleDokter}
            value={formData.schedule_doctor_id}
            onChange={handleChange("schedule_doctor_id")}
            disabled={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
            readOnly={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InputTextMaster
            name='spesialis_name'
            label='SPESIALIS'
            id='spesialis_name'
            placeholder='Spesialis'
            disabled={true}
            readOnly={true}
            value={formData.spesialis_name}
          />
        </Grid>
      </>
    );
  } else {
    return (
      <>
        <Grid item xs={4}>
          {/* <InputOptionMaster
            name='layanan_id'
            label='JENIS LAYANAN'
            id='layanan_id'
            withSearch={false}
            data={layanan}
            value={formData.layanan_id}
            onChange={handleChange("layanan_id")}
            disabled={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
            readOnly={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
          /> */}
          <div style={{ display: "flex" }}>
            <InputOptionMaster
              name='layanan_id'
              label='JENIS LAYANAN'
              id='layanan_id'
              withSearch={true}
              data={layanan}
              value={formData.layanan_id}
              labelValue={formData.layanan_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    layanan_id: null,
                    layanan_name: "Pilih JENIS LAYANAN",
                  });
                } else {
                  setFormData({
                    ...formData,
                    layanan_id: e?.value,
                    layanan_name: e?.label,
                  });
                }
              }}
              disabled={
                isNull(registrasiId)
                  ? false
                  : formData.is_update_jadwal
                  ? false
                  : true
              }
              readOnly={
                isNull(registrasiId)
                  ? false
                  : formData.is_update_jadwal
                  ? false
                  : true
              }
            />

            {/* button cek resep-itter */}
            {formData.layanan_id === 3 && (
              <Tooltip
                title={"Cari Riwayat Resep Itter"}
                aria-label="search"
              >
                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={handleShowCekResepIter}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </Tooltip>
            )}
          </div>
        </Grid>
        <Grid item xs={4}>
          <InputOptionMaster
            name='layanan_ruang_id'
            label='JENIS LAYANAN RUANG'
            id='layanan_ruang_id'
            withSearch={false}
            data={layananRuang}
            value={formData.layanan_ruang_id}
            onChange={handleChange("layanan_ruang_id")}
            disabled={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
            readOnly={
              isNull(registrasiId)
                ? false
                : formData.is_update_jadwal
                ? false
                : true
            }
          />
        </Grid>
        <FormDokter
          setFormData={setFormData}
          formData={formData}
          dokterList={dokterList}
          dokterSelect={dokterSelect}
          registrasiId={registrasiId}
        />
      </>
    );
  }
};

const FormDokter = ({
  dokterList,
  dokterSelect,
  formData,
  setFormData,
  registrasiId,
}) => {
  function getDokterSelected(id) {
    const result = dokterList.filter((e) => e.id === id);
    return result[0];
  }

  const { master } = useSelector((state) => state);

  function handleChangeDoctor(e) {
    if (e !== null) {
      const docterSelected = getDokterSelected(e.value);
      const poliklinik = master.poliklinik.list_select.find(
        (x) => parseInt(x.value) === docterSelected.poliklinik_id
      );
      setFormData({
        ...formData,
        doctor_id: e?.value,
        doctor_name: e?.label,
        poliklinik_id: docterSelected.poliklinik_id,
        poli_name: poliklinik.label,
        spesialis_name: docterSelected.spesialis_name,
      });
    } else {
      setFormData({
        ...formData,
        doctor_id: null,
        doctor_name: "Pilih Dokter",
        poliklinik_id: null,
        poli_name: "Pilih Poliklinik",
        spesialis_name: "",
      });
    }
  }

  return (
    <Grid item xs={4}>
      <InputOptionMaster
        name='doctor_id'
        label='DOKTER'
        id='doctor_id'
        withSearch={true}
        data={dokterSelect}
        labelValue={formData.doctor_name}
        value={formData.doctor_id}
        onChange={(e) => handleChangeDoctor(e)}
        disabled={
          isNull(registrasiId)
            ? false
            : formData.is_update_jadwal
            ? false
            : true
        }
        readOnly={
          isNull(registrasiId)
            ? false
            : formData.is_update_jadwal
            ? false
            : true
        }
      />
    </Grid>
  );
};
